var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vue-multiselect",
        _vm._g(
          _vm._b(
            {
              ref: "multiselect",
              attrs: { loading: _vm.loadingOptions },
              on: { open: _vm.handleOpen },
              scopedSlots: _vm._u([
                {
                  key: "noOptions",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n            Keine Einträge vorhanden.\n        "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "noResult",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n            Keine Übereinstimmungen gefunden.\n        "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "singleLabel",
                  fn: function (props) {
                    return [
                      props.option.icon
                        ? _c("span", [_c("i", { class: props.option.icon })])
                        : _vm._e(),
                      _vm._v(" "),
                      props.option.$isLabel
                        ? _c("span", [
                            _c("span", [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.toUpperCase(props.option.$groupLabel)
                                  )
                                ),
                              ]),
                            ]),
                          ])
                        : _c("span", [
                            _c(
                              "span",
                              {
                                class: _vm.transformClasses(
                                  props.option.cssClasses
                                ),
                              },
                              [_vm._v(_vm._s(props.option.text))]
                            ),
                          ]),
                    ]
                  },
                },
                {
                  key: "option",
                  fn: function (props) {
                    return [
                      props.option.icon
                        ? _c("span", [_c("i", { class: props.option.icon })])
                        : _vm._e(),
                      _vm._v(" "),
                      props.option.$isLabel
                        ? _c("span", [
                            _c("span", [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.toUpperCase(props.option.$groupLabel)
                                  )
                                ),
                              ]),
                            ]),
                          ])
                        : _c("span", [
                            _c(
                              "span",
                              {
                                class: _vm.transformClasses(
                                  props.option.cssClasses
                                ),
                              },
                              [_vm._v(_vm._s(props.option.text))]
                            ),
                          ]),
                    ]
                  },
                },
              ]),
            },
            "vue-multiselect",
            _vm.mergedProps,
            false
          ),
          _vm.commonEvents
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }